import axios from '../axios'

// hello
export const sayHello = () => {
   return axios({
        url: '/sysDept/hello',
        method: 'get'
    })
}



// WEBPACK FOOTER //
// ./src/http/moudules/hello.js